import { useCallback } from 'react';

import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { billingSubscriptions } from '#client/constants/routes';

import { ChevronLeftRoundedIcon, CloseIcon } from '../constants';
import {
  CANCEL_FLOW_TYPES,
  getCancelClickstreamProps,
  getCancelMessageId,
  subscriptionContextPropType,
} from '../utils/cancelFlowConfig';

export function SubscriptionCancelHeader({ cancelFlowType, onBack, onClose, subscriptionContext }) {
  const navigate = useNavigate();

  const handleClose = useCallback(() => (onClose ? onClose() : navigate(billingSubscriptions)), [onClose, navigate]);

  return (
    <Stack horizontal alignItems="center" justifyContent="space-between" py={1.5} px={2} bgcolor="background.default">
      {onBack ? (
        <Button
          variant="text"
          clickstreamProps={getCancelClickstreamProps(cancelFlowType, 'back', subscriptionContext)}
          onClick={onBack}
          startIcon={<ChevronLeftRoundedIcon />}
        >
          <FormattedMessage id="dashboard.subscriptionCancel.header.back" />
        </Button>
      ) : (
        <Box visibility="hidden" aria-hidden>
          <Button variant="text" startIcon={<ChevronLeftRoundedIcon />} tabIndex={-1}>
            <FormattedMessage id="dashboard.subscriptionCancel.header.back" />
          </Button>
        </Box>
      )}
      <Text size="xl" weight="bold">
        <FormattedMessage id={getCancelMessageId(cancelFlowType, 'headerTitle')} />
      </Text>
      <Button
        variant="text"
        clickstreamProps={getCancelClickstreamProps(cancelFlowType, 'close', subscriptionContext)}
        onClick={handleClose}
        endIcon={<CloseIcon fontSize="small" />}
      >
        <FormattedMessage id="dashboard.subscriptionCancel.header.close" />
      </Button>
    </Stack>
  );
}

SubscriptionCancelHeader.propTypes = {
  cancelFlowType: PropTypes.oneOf(Object.values(CANCEL_FLOW_TYPES)).isRequired,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  subscriptionContext: subscriptionContextPropType,
};
